import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {TransactionService} from 'src/app/services/transaction.service';
import {TranslateService} from '@ngx-translate/core';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {NotificationService} from '../../../services/notification.service';
import {animate, style, transition, trigger} from '@angular/animations';
import {CurrencyService} from '../../../services/currency-service';
import {TransactionDTO} from '../../../model/transactionDTO';

@Component({
  selector: 'app-transaction-assigned',
  templateUrl: './transaction-assigned.component.html',
  animations: [
    trigger('items', [
      transition(':leave', [
        animate(
          300,
          style({
            height: '0',
          })
        )
      ])
    ])
  ],
  styleUrls: ['./transaction-assigned.component.scss', '../shared-transaction.scss']
})
export class TransactionAssignedComponent implements OnInit {

  @Output()
  change: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  withdrawAssignmentUpdateCounter: EventEmitter<number> = new EventEmitter<number>();

  @ViewChild('paginator') paginator: MatPaginator;

  @Input()
  accountId: number;

  @Input()
  isLeefgeldRekening: boolean;

  public transactions: TransactionDTO[];

  length = 0;
  pageSize = 25;
  pageEvent: PageEvent = new PageEvent;

  /*
  * filtering
  * */
  sortDirectionOptions = [
    {value: 'asc', label: 'oplopend'},
    {value: 'desc', label: 'aflopend'}
  ];
  sortColumnOptions = [
    {value: 'value_date', label: 'datum'},
    {value: 'iban', label: 'IBAN'},
    {value: 'calculated_amount', label: 'bedrag'},
    {value: 'sc.name', label: 'subcategory'},
    {value: 'sc.category', label: 'category'},
    {value: 'created_at', label: 'importdatum'},
    {value: 'updated_at', label: 'datum van indelen'}
  ];
  sortColumn = 'updated_at';
  sortDirection = 'desc';
  search = '';

  constructor(
    private route: ActivatedRoute,
    private transactionService: TransactionService,
    private notificationService: NotificationService,
    public currencyService: CurrencyService,
    public translate: TranslateService) {
    translate.use('nl');
  }

  ngOnInit() {
    this.getTransactions();
    this.pageEvent.pageIndex = 0;
    this.pageEvent.pageSize = 10;
  }

  init() {
    this.getTransactions();
  }

  getTransactions(event?: PageEvent) {
    this.transactionService.getAssigned(this.accountId, event?.pageIndex ? event.pageIndex : 0, this.pageSize, this.sortColumn, this.sortDirection, this.search).subscribe((page) => {
      this.transactions = page.content;
      this.length = page.totalElements;
      this.change.emit(this.length);
    });
    return event;
  }

  withdrawAssignment(transaction) {
    this.notificationService.confirm({header: 'Categorie ontkoppelen?', ok: 'Ontkoppelen'}).then(() => {
      transaction.hidden = true;
      setTimeout(() => {
        this.transactionService.withdrawAssignment(transaction.id).subscribe(() => {
          this.withdrawAssignmentUpdateCounter.emit(this.length);
          this.change.emit(this.length);
          this.getTransactions(this.pageEvent);
          this.notificationService.success('transactie ontkoppeld');
        }, (err) => {
          transaction.hidden = false;
          // error message is hard coded in api
          this.notificationService.error(err.error.message);
        });
      }, 300);
    });
  }

  filter() {
    this.getTransactions(this.pageEvent);
  }
}
